/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreatePatternPayload } from '../model/createPatternPayload';
import { PatternData } from '../model/patternData';
import { PatternFilter } from '../model/patternFilter';
import { UpdateNotificationTemplatePayload } from '../model/updateNotificationTemplatePayload';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PatternService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create generic notification pattern
     * 
     * @param payload payload
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createGenericNotificationPattern(payload: CreatePatternPayload, observe?: 'body', reportProgress?: boolean): Observable<PatternData>;
    public createGenericNotificationPattern(payload: CreatePatternPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PatternData>>;
    public createGenericNotificationPattern(payload: CreatePatternPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PatternData>>;
    public createGenericNotificationPattern(payload: CreatePatternPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (payload === null || payload === undefined) {
            throw new Error('Required parameter payload was null or undefined when calling createGenericNotificationPattern.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PatternData>(`${this.basePath}/api/patterns`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create specific notification pattern
     * 
     * @param payload payload
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSpecificNotificationPattern(payload: CreatePatternPayload, observe?: 'body', reportProgress?: boolean): Observable<PatternData>;
    public createSpecificNotificationPattern(payload: CreatePatternPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PatternData>>;
    public createSpecificNotificationPattern(payload: CreatePatternPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PatternData>>;
    public createSpecificNotificationPattern(payload: CreatePatternPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (payload === null || payload === undefined) {
            throw new Error('Required parameter payload was null or undefined when calling createSpecificNotificationPattern.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PatternData>(`${this.basePath}/api/patterns/specific`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete generic notification pattern
     * 
     * @param patternId Notification pattern unique identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteNotificationPattern(patternId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteNotificationPattern(patternId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteNotificationPattern(patternId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteNotificationPattern(patternId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (patternId === null || patternId === undefined) {
            throw new Error('Required parameter patternId was null or undefined when calling deleteNotificationPattern.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/patterns/${encodeURIComponent(String(patternId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete specific notification pattern
     * 
     * @param patternId Notification pattern unique identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSpecificNotificationPattern(patternId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteSpecificNotificationPattern(patternId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteSpecificNotificationPattern(patternId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteSpecificNotificationPattern(patternId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (patternId === null || patternId === undefined) {
            throw new Error('Required parameter patternId was null or undefined when calling deleteSpecificNotificationPattern.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/patterns/${encodeURIComponent(String(patternId))}/specific`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all notification patterns
     * 
     * @param filter Pattern filter
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllNotificationPatterns(filter?: PatternFilter, observe?: 'body', reportProgress?: boolean): Observable<Array<PatternData>>;
    public getAllNotificationPatterns(filter?: PatternFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PatternData>>>;
    public getAllNotificationPatterns(filter?: PatternFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PatternData>>>;
    public getAllNotificationPatterns(filter?: PatternFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<PatternData>>(`${this.basePath}/api/patterns/search`,
            filter,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all notification patterns for a session
     * 
     * @param sessionId Session to find
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllNotificationPatternsSession(sessionId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<PatternData>>;
    public getAllNotificationPatternsSession(sessionId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PatternData>>>;
    public getAllNotificationPatternsSession(sessionId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PatternData>>>;
    public getAllNotificationPatternsSession(sessionId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling getAllNotificationPatternsSession.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<PatternData>>(`${this.basePath}/api/patterns/sessions/${encodeURIComponent(String(sessionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all notification patterns for a step
     * 
     * @param stepId Step to find
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllNotificationPatternsStep(stepId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<PatternData>>;
    public getAllNotificationPatternsStep(stepId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PatternData>>>;
    public getAllNotificationPatternsStep(stepId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PatternData>>>;
    public getAllNotificationPatternsStep(stepId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (stepId === null || stepId === undefined) {
            throw new Error('Required parameter stepId was null or undefined when calling getAllNotificationPatternsStep.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<PatternData>>(`${this.basePath}/api/patterns/steps/${encodeURIComponent(String(stepId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get best suited notification pattern
     * 
     * @param filter Session filter (null values ignored)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBestSuitedNotificationPattern(filter?: PatternFilter, observe?: 'body', reportProgress?: boolean): Observable<PatternData>;
    public getBestSuitedNotificationPattern(filter?: PatternFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PatternData>>;
    public getBestSuitedNotificationPattern(filter?: PatternFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PatternData>>;
    public getBestSuitedNotificationPattern(filter?: PatternFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PatternData>(`${this.basePath}/api/patterns/best-suited`,
            filter,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get notification pattern
     * 
     * @param patternId Notification pattern unique identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNotificationPattern(patternId: number, observe?: 'body', reportProgress?: boolean): Observable<PatternData>;
    public getNotificationPattern(patternId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PatternData>>;
    public getNotificationPattern(patternId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PatternData>>;
    public getNotificationPattern(patternId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (patternId === null || patternId === undefined) {
            throw new Error('Required parameter patternId was null or undefined when calling getNotificationPattern.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PatternData>(`${this.basePath}/api/patterns/${encodeURIComponent(String(patternId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update generic notification pattern
     * 
     * @param patternId Notification pattern unique identifier
     * @param payload payload
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateGenericNotificationPattern(patternId: number, payload: UpdateNotificationTemplatePayload, observe?: 'body', reportProgress?: boolean): Observable<PatternData>;
    public updateGenericNotificationPattern(patternId: number, payload: UpdateNotificationTemplatePayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PatternData>>;
    public updateGenericNotificationPattern(patternId: number, payload: UpdateNotificationTemplatePayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PatternData>>;
    public updateGenericNotificationPattern(patternId: number, payload: UpdateNotificationTemplatePayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (patternId === null || patternId === undefined) {
            throw new Error('Required parameter patternId was null or undefined when calling updateGenericNotificationPattern.');
        }

        if (payload === null || payload === undefined) {
            throw new Error('Required parameter payload was null or undefined when calling updateGenericNotificationPattern.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<PatternData>(`${this.basePath}/api/patterns/${encodeURIComponent(String(patternId))}`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update specific notification pattern
     * 
     * @param patternId Notification pattern unique identifier
     * @param payload payload
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateSpecificNotificationPattern(patternId: number, payload: UpdateNotificationTemplatePayload, observe?: 'body', reportProgress?: boolean): Observable<PatternData>;
    public updateSpecificNotificationPattern(patternId: number, payload: UpdateNotificationTemplatePayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PatternData>>;
    public updateSpecificNotificationPattern(patternId: number, payload: UpdateNotificationTemplatePayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PatternData>>;
    public updateSpecificNotificationPattern(patternId: number, payload: UpdateNotificationTemplatePayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (patternId === null || patternId === undefined) {
            throw new Error('Required parameter patternId was null or undefined when calling updateSpecificNotificationPattern.');
        }

        if (payload === null || payload === undefined) {
            throw new Error('Required parameter payload was null or undefined when calling updateSpecificNotificationPattern.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<PatternData>(`${this.basePath}/api/patterns/${encodeURIComponent(String(patternId))}/specific`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
